// extracted by mini-css-extract-plugin
module.exports = {"product-details__badge-title--wrapper":"product-details__badge-title--wrapper--vtpd5","product-details__favorites":"product-details__favorites--vtpd5"};